export default __webpack_public_path__ + "static/media/banner.5e556db1.png";